<template>
  <div>
    <div>
      <h1 class="mdn-Heading mdn-Heading--sm">Designações provedores</h1>

      <ModosWebFiltroInlineCollapseComponent :campos="camposFiltrosComputed" :key="filtroKey" :inicialOpen="false"
        @modosWebFormFilterDadosClick="aplicarFiltro" @modosWebFormFilterDadosChange="(d) => { }"
        @modosWebFormFilterLimpar="resetarFiltro" />

      <SGPModalComponent v-if="abrirModal" tamanho="lg" titulo="Designação" @sgpModalFechar="fecharModal"
        :mostrarFooter="false">
        <FormularioCtrlDesignacaoComponent :tipoFormulario="tipoFormulario" :provedor="designacaoSelecionado"
          @designacaoSalva="fecharModal" />
      </SGPModalComponent>

      <SGPBotaoAdicionarNovoComponent @sgpAdiconarNovoEmit="adicionarNovo" />

      <template v-if="designacao.length">
        <SGPPaginacaoComponent :paginacao="paginacao" @sgpAtualizarPaginacao="realizarPaginacao"
          :key="paginacao?.current_page">

          <SGPTabelaComponent :colunas="colunas" :dados="designacao" :usuarioPodeEditar="true"
            :usuarioPodeExcluir="false" :botaoInline="false" :somenteLeitura="false"
            @sgpTabelaLinhasSelecionadasEmit="gerenciadorDeSelecionados"
            @sgpTabelaEditarSelecionadoEmit="editarSelecionado"
            @sgpTabelaVincularSelecionadoEmit="handleBotaoCustom" />
        </SGPPaginacaoComponent>
      </template>

      <SGPAlertaComponent v-else />
      <SGPLoadingComponent v-if="loadingDesignacao" />
    </div>

  </div>
</template>


<script>
import { mapActions, mapGetters } from 'vuex'
import FormularioCtrlDesignacaoComponent from '../components/FormularioCtrlDesignacaoComponent.vue'
import ModosWebFiltroInlineCollapseComponent from '@/common/modosweb-components/ModosWebFiltroInlineCollapseComponent.vue'

export default {
  name: 'ctrlDesignacaoPage',

  components: {
    FormularioCtrlDesignacaoComponent,
    ModosWebFiltroInlineCollapseComponent
  },

  data() {
    return {
      mostrarFiltro: false,
      mostrarEditar: true,
      designacaoSelecionados: [],
      designacaoSelecionado: {},
      abrirModal: false,
      tipoFormulario: 'salvar',
      filtro: {},
      filtroKey: 1
    }
  },

  created() {
    this.listarDesignacao(this.montarParametros());
  },

  computed: {
    ...mapGetters('ctrlDesignacao', ['listaDeDesignacao', 'loadingDesignacao', 'paginacao']),

    designacao() {
      return this.listaDeDesignacao.map(designacoes => {
        return {
          ...designacoes,
        }
      })
    },

    camposFiltrosComputed() {
      return [
        { name: 'provedor', type: 'text', label: 'Provedor' },
        { name: 'id_book', type: 'text', label: 'Id book' },
        { name: 'holding', type: 'text', label: 'Holding' },
        { name: 'designacao', type: 'text', label: 'Designação' },
        { name: 'valor_mensal', type: 'text', label: 'Valor mensal' },
        { name: 'sla', type: 'text', label: 'SLA' },
        { name: 'acesso_lp', type: 'text', label: 'Designação provedor' },
        { name: 'uf_ponta_a', type: 'text', label: 'UF Ponta A' },
        { name: 'uf_ponta_b', type: 'text', label: 'UF Ponta B' },
        { name: 'regional', type: 'text', label: 'Regional' },
        { name: 'regional_sigla', type: 'text', label: 'Regional Sigla' },
        { name: 'anomes', type: 'text', label: 'Anomes' },
        { name: 'status_acesso', type: 'text', label: 'Status do acesso' },
        { name: 'grupo_operadora', type: 'text', label: 'Grupo operadora' },
      ]
    },

    colunas() {
      return [
        {
          key: 'selecionar',
          label: '',
          sortable: false
        },
        {
          key: 'provedor',
          label: 'Provedor',
          sortable: false
        },
        {
          key: 'id_book',
          label: 'Book ID',
          sortable: false
        },
        {
          key: 'holding',
          label: 'Holding',
          sortable: false
        },
        {
          key: 'designacao',
          label: 'Designação',
          sortable: false
        },
        {
          key: 'acesso_lp',
          label: 'Designação provedor',
          sortable: false
        },
        {
          key: 'valor_mensal',
          label: 'Valor mensal',
          sortable: false
        },
        {
          key: 'sla',
          label: 'SLA',
          sortable: false
        },
        {
          key: 'uf_ponta_a',
          label: 'UF',
          sortable: false
        },
        {
          key: 'uf_ponta_b',
          label: 'UF Ponta B',
          sortable: false
        },
        {
          key: 'regional',
          label: 'Regional',
          sortable: false
        },
        {
          key: 'regional_sigla',
          label: 'Regional Sigla',
          sortable: false
        },
        {
          key: 'anomes',
          label: 'Ano/mês',
          sortable: false
        },
        {
          key: 'status_acesso',
          label: 'Status do acesso',
          sortable: false
        },
        {
          key: 'grupo_operadora',
          label: 'Grupo operadora',
          sortable: false
        },
      ]
    }
  },

  methods: {
    ...mapActions('ctrlDesignacao',
      [
        'listarDesignacao',
      ]),


    resetarFiltro() {
      this.filtro = {};

      this.listarDesignacao(this.montarParametros({
        page: 1,
        current_page: 1
      }));

      this.filtroKey++;
    },

    gerenciadorDeSelecionados(selecionados) {
      this.designacaoSelecionados = selecionados;
    },

    fecharModalDetalhes() {
      this.designacaoSelecionado = {};
    },

    fecharModalVincular() {
      this.designacaoSelecionado = {};
      this.listarDesignacao(this.montarParametros());
    },

    montarParametros(extra = {}) {
      return {
        per_page: this.paginacao?.per_page || 20,
        page: this.paginacao?.current_page || 1,
        current_page: this.paginacao?.current_page || 1,
        ...extra,
      }
    },

    adicionarNovo() {
      this.designacaoSelecionado = {};
      this.tipoFormulario = 'salvar';
      this.abrirModal = true;
    },

    fecharModal() {
      this.abrirModal = false;
      this.designacaoSelecionado = {};
      this.tipoFormulario = 'salvar';
      this.listarDesignacao(this.montarParametros());
    },

    editarSelecionado () {
      this.tipoFormulario = 'editar';
      this.designacaoSelecionado = this.designacaoSelecionados[0];
      this.abrirModal = true;
    },

    async aplicarFiltro(dados) {
      this.filtro = dados || {};
      await this.listarDesignacao(this.montarParametros({
        ...this.filtro,
        page: 1,
        current_page: 1
      }));
    },

    realizarPaginacao(paginate) {
      const current = paginate.current_page || 1
      const perPage = paginate.per_page || this.paginacao?.per_page || 20
      this.listarDesignacao(
        this.montarParametros({
          page: current,
          current_page: current,
          per_page: perPage
        })
      )
    },

  }
}
</script>
